import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ItestState } from "./tests.types";
import axiosInstance from "config/axios";
const initialState: ItestState = {
  test: [],
  singleTest: {
    _id: "",
    petId: "",
    kitId: "",
    hospitalName: "",
    ActivationDate: "",
    riskLevel: "",
    testResult: "",
    submit: false,
    userId: "",
  },
  testError: {},
  istestActivityInProcess: false,
  testSuccessMesssage: "",
  totalRecords: 0,
  totalPages: 0,
};

export const getTests = createAsyncThunk("getTests/test", async (_, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance().get("/labresult/get-lab-result-by-userId");
    return data;
  } catch (error: any) {
    return rejectWithValue(error.response);
  }
});

export const getAllTests = createAsyncThunk(
  "getAllTests/test",
  async ({ page, userName }: { page: number; userName?: string }, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance().get(`/labresult/get-lab-results?page=${page}&name=${userName}`);

      return data;
    } catch (error: any) {
      return rejectWithValue(error.response);
    }
  }
);

export const getAllHospitalTests = createAsyncThunk(
  "getAllHospitalTests/test",
  async (page: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance().get(`/labresult/get-hospital-lab-results?page=${page}`);

      return data;
    } catch (error: any) {
      return rejectWithValue(error.response);
    }
  }
);

export const getsubmittedTests = createAsyncThunk("getsubmitTests/test", async (page: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance().get(`/labresult/get-submitted-lab-results?page=${page}`);

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response);
  }
});

// reset Submitted Tests
export const resetsubmittedTests = createAsyncThunk(
  "resetsubmitTests/test",
  async (resultId: string, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance().put(`/labresult/reset-lab-result/${resultId}`);
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response);
    }
  }
);

export const getnotsubmittedTests = createAsyncThunk(
  "getnotsubmitTests/test",
  async (page: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance().get(`/labresult/get-notsubmitted-lab-results?page=${page}`);

      return data;
    } catch (error: any) {
      return rejectWithValue(error.response);
    }
  }
);

export const getnotReceiveTests = createAsyncThunk("getnotReceiveTests/test", async (_, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance().get(`/labresult/get-notsubmitted-lab-results?type=all`);

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response);
  }
});

export const getPetTests = createAsyncThunk("getPetTests/test", async (petId: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance().get(`/labresult/get-lab-result-by-petId/${petId}`);

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response);
  }
});

export const createLabResult = createAsyncThunk("createLabResult/test", async (result: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance().put(`/labresult/update-lab-result/${result.riskData.resultId}`, result);

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response);
  }
});

export const getSingletest = createAsyncThunk("getSingletest/test", async (testID: any, { rejectWithValue }) => {
  try {
    const { data } = await axiosInstance().get(`/test/get-test/${testID}`);

    return data;
  } catch (error: any) {
    return rejectWithValue(error.response);
  }
});

export const updateSubscription = createAsyncThunk(
  "updateKit/subscription",
  async (payload: any, { rejectWithValue }) => {
    try {
      const { data } = await axiosInstance().put(`/kit/update-subscription/${payload?.kitId}`, {
        subscription: payload?.subscription,
      });
      return data;
    } catch (error: any) {
      return rejectWithValue(error.response);
    }
  }
);
const testSlice = createSlice({
  name: "testSlice",
  initialState: { ...initialState, name: "testInitialState" },
  reducers: {
    errorClean: (state) => {
      state.testError = {
        code: null,
        message: "",
        error: "",
      };
    },
    messageClean: (state) => {
      state.testSuccessMesssage = "";
    },
    petTestsClean: (state) => {
      state.test = [];
    },
  },
  extraReducers: (builder) => {
    // get users all tests cases
    builder.addCase(getTests.pending, (state, action: any) => {
      state.istestActivityInProcess = true;
    });

    builder.addCase(getTests.rejected, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.testError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(getTests.fulfilled, (state, action: any) => {
      state.istestActivityInProcess = false;

      state.test = action.payload.labResults;
    });

    // get all tests cases
    builder.addCase(getAllTests.pending, (state, action: any) => {
      state.istestActivityInProcess = true;
    });

    builder.addCase(getAllTests.rejected, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.testError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(getAllTests.fulfilled, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.totalRecords = action.payload.totalresults;
      state.totalPages = action.payload.totalPages;
      state.test = action.payload.labResults;
      state.testSuccessMesssage = action.payload.message;
    });

    // get all hospital test
    builder.addCase(getAllHospitalTests.pending, (state, action: any) => {
      state.istestActivityInProcess = true;
    });

    builder.addCase(getAllHospitalTests.rejected, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.testError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(getAllHospitalTests.fulfilled, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.totalRecords = action.payload.totalresults;
      state.totalPages = action.payload.totalPages;
      state.test = action.payload.labResults;
      state.testSuccessMesssage = action.payload.message;
    });

    // get submitted tests cases
    builder.addCase(getsubmittedTests.pending, (state, action: any) => {
      state.istestActivityInProcess = true;
    });

    builder.addCase(getsubmittedTests.rejected, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.testError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(getsubmittedTests.fulfilled, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.totalRecords = action.payload.totalresults;
      state.totalPages = action.payload.totalPages;
      state.test = action.payload.labResults;
      state.testSuccessMesssage = action.payload.message;
    });

    // reset submitted tests cases
    builder.addCase(resetsubmittedTests.pending, (state, action: any) => {
      state.istestActivityInProcess = true;
    });

    builder.addCase(resetsubmittedTests.rejected, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.testError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(resetsubmittedTests.fulfilled, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.totalRecords = action.payload.totalresults;
      state.totalPages = action.payload.totalPages;
      state.test = action.payload.labResults;
      state.testSuccessMesssage = action.payload.message;
    });

    // get not submitted tests cases
    builder.addCase(getnotsubmittedTests.pending, (state, action: any) => {
      state.istestActivityInProcess = true;
    });

    builder.addCase(getnotsubmittedTests.rejected, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.testError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(getnotsubmittedTests.fulfilled, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.totalRecords = action.payload.totalresults;
      state.totalPages = action.payload.totalPages;
      state.test = action.payload.labResults;
      state.testSuccessMesssage = action.payload.message;
    });

    // get not submitted tests cases
    builder.addCase(getnotReceiveTests.pending, (state, action: any) => {
      state.istestActivityInProcess = true;
    });

    builder.addCase(getnotReceiveTests.rejected, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.testError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(getnotReceiveTests.fulfilled, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.totalRecords = action.payload.totalresults;
      state.totalPages = action.payload.totalPages;
      state.test = action.payload.labResults;
      state.testSuccessMesssage = action.payload.message;
    });

    // get create lab test results cases
    builder.addCase(createLabResult.pending, (state, action: any) => {
      state.istestActivityInProcess = true;
    });

    builder.addCase(createLabResult.rejected, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.testError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(createLabResult.fulfilled, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.testSuccessMesssage = action.payload.message;

      // state.test = action.payload.labResults;
    });

    // get all pet tests cases
    builder.addCase(getPetTests.pending, (state, action: any) => {
      state.istestActivityInProcess = true;
    });

    builder.addCase(getPetTests.rejected, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.testError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(getPetTests.fulfilled, (state, action: any) => {
      state.istestActivityInProcess = false;
      // state.testSuccessMesssage = action.payload.message;

      state.test = action.payload.result;
    });

    // get single test by testID cases
    builder.addCase(getSingletest.pending, (state, action: any) => {
      state.istestActivityInProcess = true;
    });

    builder.addCase(getSingletest.rejected, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.testError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(getSingletest.fulfilled, (state, action: any) => {
      state.istestActivityInProcess = false;
      // state.testSuccessMesssage = action.payload.message;

      state.singleTest = action.payload.test;
    });
    // update user subscription
    builder.addCase(updateSubscription.pending, (state, action: any) => {
      state.istestActivityInProcess = true;
    });

    builder.addCase(updateSubscription.rejected, (state, action: any) => {
      state.istestActivityInProcess = false;
      state.testError = {
        code: action.payload.status,
        message: action.payload.data.message,
      };
    });

    builder.addCase(updateSubscription.fulfilled, (state, action: any) => {
      let updatedTests = state.test?.filter((kit) => kit.kitId._id === action.payload.kit._id);
      if (updatedTests?.length) {
        for (let i = 0; i < updatedTests?.length; i++) {
          updatedTests[i].kitId.subscription = action.payload.kit?.subscription;
        }
      }
      state.istestActivityInProcess = false;
    });
  },
});
export const { errorClean, messageClean, petTestsClean } = testSlice.actions;

export default testSlice.reducer;
